import styled, { css } from 'styled-components';
import { color } from './helpers/variables';
import { dynamicFontSize } from './helpers/mixins';

export const Price = styled.p`
  font-size: 18px;
  font-weight: ${props => props.fontWeight};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  margin-top: 0;
  color: ${props => (props.sale ? color.sale : color.black)};
  display: ${props => (props.inline ? 'inline' : 'block')};
  text-align: inherit;
  
  ${props =>
    props.originalPrice &&
    css`
      color: ${color.darkgrey};
      font-size: 13px;
      text-decoration: line-through;
      margin-left: 0.5em;
      font-style: italic;
      font-weight: normal;
    `}
  
  ${props =>
    props.small &&
    css`
      ${dynamicFontSize(12, 15)};
      margin-top: 0.35em;
    `}
  
  ${props =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}
`;



// WEBPACK FOOTER //
// ./src/styles/Price.js